module.exports = __webpack_public_path__ + "img/magic.5b915a97.jpeg";